import { fetchBrands } from "src/services/BrandApi";

export const loadBrands = async (setBrands) => {
  try {
    const data = await fetchBrands();
    const formattedBrands = data.map((brand) => ({
      imageUrl: brand.logo,
      name: brand.name,
    }));
    setBrands(formattedBrands);
  } catch (error) {
    console.error("Failed to fetch brands:", error);
  }
};
